import { hashIds } from './hashId'
export function generateUrl(entity, type) {
    if (!entity) return ''

    if (type === 'news') {
        if (!entity.ext_id) {
            console.warn("can't generate url for news, need ext_id", entity)
            return ''
        }
        const slug = entity.seo_slug
            ? entity.seo_slug.replace(/\s/g, '-')
            : entity.title
                  ?.trim()
                  ?.replace(/[^\u0600-\u06FFa-zA-Z]/g, '-')
                  ?.replace(/-{2,}/g, '-') ?? null
        const id = hashIds(entity.ext_id)
        return `/blog/${id}${slug ? '/' + slug : ''}`
    }
    if (type === 'broker') {
        const slug =
            entity.title
                ?.trim()
                ?.replace(/[^\u0600-\u06FFa-zA-Z]/g, '-')
                ?.replace(/-{2,}/g, '-') ?? null

        return `/brokers${slug ? '/' + slug : ''}`
    }
}
